import { Service } from 'typedi';

import { IAutoLoginModel } from '../models';
import { LoginDataBuilder } from './logindata.builder.service';

@Service()
export abstract class AutoLoginDataBuilder<T extends IAutoLoginModel> extends LoginDataBuilder<T> {}
